import React from 'react'
import {
  Box,
  Container,
  Grid,
  GridItem,
  Stack,
  Text,
  useMediaQuery
} from '@chakra-ui/react'
import Image from 'next/image'
import ourStoryBodyBottom from '@images/our-story-body-bottom.png'
import ourStoryBodyTop from '@images/our-story-body-top.png'
import { LogoIcon } from '@icons/index'
import { useResponsive } from '@common/hooks'

const OurStoryBody = () => {
  const { xlMax, xlMin } = useResponsive()

  const [isSmallerThan1600] = useMediaQuery('(max-width: 1600px)')

  return (
    <Box>
      <Box position="relative">
        <Box position={xlMax ? 'initial' : 'absolute'} top={0} right={0}>
          <Box
            position="relative"
            style={{
              aspectRatio: '422/470'
            }}
            display="inline"
            data-aos="fade-left"
          >
            <Image
              src={ourStoryBodyTop}
              alt="We are all about Happy Habitats."
              style={{
                marginLeft: 'auto'
              }}
            />
          </Box>
        </Box>

        <Container pt={xlMax ? 12 : 56}>
          <Grid templateColumns="repeat(12, 1fr)" gap={6} data-aos="fade-up">
            <GridItem
              colSpan={{
                lg: 8,
                base: 12
              }}
            >
              <Box>
                <Text textStyle="ourStoryTitle">Brand Belief</Text>

                <Text
                  textStyle="ourStoryTitleLarge"
                  display={'block'}
                  my={2}
                  mt={{
                    lg: 14,
                    base: 8
                  }}
                >
                  We are all about making life
                  <Text as="span" color={'red'} display="block">
                    Everyday Easier
                  </Text>
                </Text>
                <Stack
                  gap={2}
                  mt={{
                    lg: 8,
                    base: 4
                  }}
                >
                  <Text textStyle="ourStoryTextMedium">
                    Bringing happy rituals possible to very home, every
                    lifestyle. Everyday, we devote ourselves to adding zest to
                    life. Putting joy in every household. Empowering the young
                    and the young at heart with innovative home solutions that
                    make life easier and chores breezier. At JML, real pleasure
                    comes from habituating in solving problems for our
                    customers...Happily going the extra mile always with a
                    sincere smile.
                  </Text>
                  <Text textStyle="ourStoryTextMedium">
                    At JML, every product is responsibly sourced, rigorously
                    tested and expertly curated so that customers get not just
                    the best product for their money but the best solutions for
                    their lifestyle. Our idea of everyday easier is innovatively
                    simple: To put the right products in the right hands, in
                    every lifestyle, every household.
                  </Text>
                  <Box>
                    <Text
                      textStyle="ourStoryTextMedium"
                      fontFamily="DM Sans Bold"
                      lineHeight={{
                        lg: '38px',
                        base: '34px'
                      }}
                    >
                      Experience Happy like never before.
                    </Text>
                    <Text
                      textStyle="ourStoryTextMedium"
                      fontFamily="DM Sans Bold"
                      lineHeight={{
                        lg: '38px',
                        base: '34px'
                      }}
                    >
                      Bring your every day to a new level, only with JML.
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </GridItem>

            {/* <GridItem
              colSpan={{
                lg: 4,
                base: 12
              }}
              display="flex"
              alignItems="flex-end"
              justifyContent="flex-end"
            >
              <LogoIcon width={xlMin ? 320 : 160} height={xlMin ? 237 : 120} />
            </GridItem> */}
          </Grid>
        </Container>

        <Box
          bg="bg"
          width={{
            base: 2,
            lg: isSmallerThan1600 ? 2 : '80px'
          }}
          height="632px"
          position="absolute"
          bottom={0}
          left={0}
        ></Box>
      </Box>

      <Grid
        templateColumns="repeat(12, 1fr)"
        mt={{
          lg: 20,
          base: 4
        }}
        data-aos="fade-up"
      >
        <GridItem
          colStart={xlMax ? 5 : 6}
          colEnd={xlMax ? 11 : 10}
          style={{
            aspectRatio: '625/440'
          }}
          position="relative"
        >
          <Image
            src={ourStoryBodyBottom}
            alt="Experience Happy like never before."
            fill
          />
        </GridItem>
      </Grid>
    </Box>
  )
}

export default OurStoryBody
